import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import {
  AddReferenceLayerData,
  ReferenceLayerUploadResponse,
} from '../../../@construction/modules/reference-layers/reference-layers.types';
import { TBResponse } from '@construction/models/wbs-elements.model';
import { ReferenceLayer } from '../../../@construction/modules/project-edit/projects.types';

@Injectable({
  providedIn: 'root',
})
export class ReferenceLayersApiService {
  private http = inject(HttpClient);
  constructor() {}

  public getReferenceLayers(projectId: string) {
    const url = `${environment.apiUrl}/${environment.apiVersion}/construction_projects/${projectId}/reference_layers/?page_size=100`;

    return this.http.get<TBResponse<ReferenceLayer[]>>(url);
  }

  public createReferenceLayer(projectId: string, data: ReferenceLayer) {
    const url = `${environment.apiUrl}/${environment.apiVersion}/construction_projects/${projectId}/reference_layers/`;

    return this.http.post<TBResponse<ReferenceLayer[]>>(url, data);
  }

  public orderReferenceLayers(projectId: string, data: { uuids: string[] }) {
    const url = `${environment.apiUrl}/${environment.apiVersion}/construction_projects/${projectId}/reference_layers/order`;

    return this.http.post<TBResponse<ReferenceLayer[]>>(url, data);
  }

  public editReferenceLayer(projectId: string, layerId: string, data: ReferenceLayer) {
    const url = `${environment.apiUrl}/${environment.apiVersion}/construction_projects/${projectId}/reference_layers/${layerId}/`;

    return this.http.patch<TBResponse<ReferenceLayer[]>>(url, data);
  }

  public deleteReferenceLayer(projectId: string, layerId: string) {
    const url = `${environment.apiUrl}/${environment.apiVersion}/construction_projects/${projectId}/reference_layers/${layerId}/`;

    return this.http.delete<TBResponse<ReferenceLayer[]>>(url);
  }

  public uploadReferenceLayerFile(projectId: string, data: FormData): Observable<ReferenceLayerUploadResponse> {
    const url = `${environment.apiUrl}/${environment.apiVersion}/construction_projects/${projectId}/reference_layer_files/`;

    return this.http.post<TBResponse<ReferenceLayerUploadResponse>>(url, data).pipe(map((res) => res.data));
  }

  public uploadReferenceLayer(
    projectId: string,
    fileId: string,
    data: AddReferenceLayerData[],
  ): Observable<ReferenceLayer[]> {
    const url = `${environment.apiUrl}/${environment.apiVersion}/construction_projects/${projectId}/reference_layer_files/${fileId}/import/`;

    return this.http.post<TBResponse<ReferenceLayer[]>>(url, data).pipe(map((res) => res.data));
  }
}
